module.exports = __webpack_public_path__ + "img/platform_en_logo_95e212406.png";